import script from "./flexband.vue?vue&type=script&lang=js"
export * from "./flexband.vue?vue&type=script&lang=js"

import "./flexband.vue?vue&type=style&index=0&id=54cc26a2&lang=scss"

const __exports__ = script;

export default __exports__